export enum OrderStatusEnum {
  editableForOnlyMechanics = 0,
  editableForExecutorsAndWharfMechanics = 1,
  editableForNoOne = 2
}
